import React, { Component } from "react";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables-bitozen";
import LoadingBar from "react-top-loading-bar";
import PopUp from "../../../pages/PopUpAlert";
import API from "../../../../Services/Api";
import { checkResponseError } from "../../../../Services/Utils";
import { connect } from "react-redux";
import * as R from "ramda";
import { Redirect } from "react-router-dom";
import AuthAction from "../../../../Redux/AuthRedux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import FormPricelist from "./formPricelist";

import Button from "../../../../modules/commons/Button";
import SimpleInputRow from "../../../../modules/SimpleInputRow";
import SimpleInputRowSmall from "../../../../modules/SimpleInputRowSmall";

const UtilsButtonLogin = require("../../../../Services/UtilsButtonLogin");

const ct = require("../../../../modules/custom/customTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions6();

class Pricelist extends Component {
  constructor() {
    super();
    this.state = {
      rawData: [],
      dataTable: [
        [
          "1",
          "OTR7401",
          "J10",
          "JABAR 3",
          "OTR Jabar 3",
          "02-03-2022",
          "03-04-2022",
          "Active",
        ],
        [
          "2",
          "OTR7402",
          "J11",
          "JABAR 4",
          "OTR Jabar 4",
          "05-05-2022",
          "06-06-2022",
          "Active",
        ],
        [
          "3",
          "OTR7403",
          "J12",
          "JABAR 5",
          "OTR Jabar 5",
          "08-08-2022",
          "09-09-2022",
          "Inactive",
        ],
        [
          "4",
          "OTR7404",
          "J13",
          "JABAR 6",
          "OTR Jabar 6",
          "11-11-2022",
          "12-12-2022",
          "Active",
        ],
        [
          "5",
          "OTR7405",
          "J14",
          "JABAR 7",
          "OTR Jabar 7",
          "02-02-2023",
          "03-03-2023",
          "Active",
        ],
        [
          "6",
          "OTR7406",
          "J15",
          "JABAR 8",
          "OTR Jabar 8",
          "04-04-2023",
          "05-05-2023",
          "Inactive",
        ],
        [
          "7",
          "OTR7407",
          "J16",
          "JABAR 9",
          "OTR Jabar 9",
          "06-06-2023",
          "07-07-2023",
          "Active",
        ],
        [
          "8",
          "OTR7408",
          "J17",
          "JABAR 10",
          "OTR Jabar 10",
          "08-08-2023",
          "09-09-2023",
          "Active",
        ],
      ],
      selectedIndex: [],
      dmlchoices: [""],
      createVisible: false,
      updateVisible: false,
      deletePopUpVisible: false,
      savePopUpVisible: false,
      loadSave: false,
      allowResize: false,
      defaultSize: 0,
      minSize: 0,
      maxSize: 0,
      timeout: 1000 * 100 * 9,
      isTimedOut: false,
      toCount: 0,
      table_limit: 10,
      table_page: 0,
      table_query: "",
      createVisible2: false,
      tabIndex: 0,
      checkTab: false,
      data: {},
      dataDto: {},
      buttonAccess: {},
      cari: null,
      parts: null,
    };
    this.idleTimer = null;
  }

  logout() {
    this.props.authLogout();
    return <Redirect to={{ pathname: "/" }} />;
  }

  onAction() {
    this.setState({ isTimedOut: false });
  }

  onActive() {
    this.setState({ isTimedOut: false });
  }

  onIdle() {
    const isTimedOut = this.state.isTimedOut;
    if (isTimedOut) {
      alert("Your session has timed out. Please log in again");
      this.logout();
    } else {
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
  }

  componentDidMount() {
    UtilsButtonLogin.buttonAccess("MASTER-022", (response) => {
      // console.log("ORI ", response);
      this.setState(
        {
          buttonAccess: response,
        },
        () => {
          this.getCountPage(this.state.table_page, this.state.table_limit);
        }
      );
    });
  }

  getCountPage = async (page, limit) => {
    console.log("getCountPage");
    let payload = {
      // limit: limit,
      // offset: page,
      // filter: this.state.table_query,
      // companyId: this.state.dataDto.companyId,
      // companyGroupId: null,
      // category: null,
      // isActive: null,
      // sortBy: this.state.dataDto.sortBy ?? "",
      // orderBy: this.state.dataDto.orderBy ?? "",
    };
    console.log(payload);

    // let res = await API.create('LOCAL_BANK').getBank(payload)
    // if (res.ok) {
    //     console.log('here')
    //     if (res.data.data === null) {
    //         this.setState({ dataTable: [] })
    //     } else {
    //         // console.log(JSON.stringify(res.data.data, null, 2));
    //         let dataTable = res.data.data && res.data.data.map((value) => {
    //             const { bankcode, bankname, accountnumber, address, kecamatan, kota, provinsi, kodepos, phonenumber, namadealer, integration, status } = value;
    //             return [
    //                 bankcode,
    //                 bankname,
    //                 accountnumber,
    //                 address,
    //                 kecamatan,
    //                 kota,
    //                 provinsi,
    //                 kodepos,
    //                 phonenumber,
    //                 namadealer,
    //                 integration,
    //                 status?"ACTIVE":"NONACTIVE",
    //             ];
    //         });
    //         console.log('datatable', dataTable)
    //         this.setState({
    //             rawData: res.data.data && res.data.data.listUser,
    //             dataTable,
    //             toCount: res.data.data && res.data.data.dataOfRecord
    //         })
    //         this.onFinishFetch();
    //     }
    // } else{
    //     console.log('error')
    // }
  };

  handleClearUser = (e) => {
    this.setState(
      {
        table_page: 0,
        toCount: 0,
        data: {},
        dataDto: {},
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  handleSearch = (eventSearch) => {
    this.setState(
      {
        table_page: 0,
        dataDto: eventSearch ? this.state.data : this.state.dataDto,
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  isLoad(visible) {
    this.setState({ loadSave: visible });
  }

  checkResponse(res, type) {
    if (res.ok && res.data.status === "S") {
      type === "delete" && this.setState({ deletePopUpVisible: false });
      setTimeout(() => {
        this.openSavePopUp();
      }, 500);
    } else {
      this.isLoad(false);
      checkResponseError(res);
    }
  }

  onchangeInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({
      data: {
        ...this.state.data,
        [name]: value,
      },
    });
  };

  handleSubmit = async (response) => {
    this.checkResponse(response);
  };

  handleDelete = async () => {
    this.isLoad(true);
    let payload = { ...this.state.rawData[this.state.selectedIndex] };
    payload.action = "DELETE";

    let response = await API.create("MASTERDATA_EKSAD").postSaveUser(payload);
    this.checkResponse(response, "delete");
    this.isLoad(false);
  };

  handlePopUp = () => {
    this.handleSearch();
    this.setState({
      savePopUpVisible: false,
      createVisible: false,
      createVisible2: false,
    });
  };

  startFetch = () => {
    this.LoadingBar.continousStart();
  };

  onFinishFetch = () => {
    if (typeof this.LoadingBar === "object") this.LoadingBar.complete();
  };

  openCreateForm = () => {
    this.setState({ createVisible: !this.state.createVisible });
  };

  openUpdateForm = () => {
    this.setState({ updateVisible: !this.state.updateVisible });
  };

  openSavePopUp = () => {
    this.setState({
      savePopUpVisible: !this.state.savePopUpVisible,
      loadSave: false,
    });
  };

  openDeletePopup = (index) => {
    this.setState({
      deletePopUpVisible: !this.state.deletePopUpVisible,
      selectedIndex: index,
    });
  };

  columnsUser = [
    { name: "No" },
    { name: "Price List ID" },
    { name: "MD" },
    { name: "Region" },
    { name: "Deskripsi" },
    { name: "Start Date" },
    { name: "End Date" },
    { name: "Status" },
    {
      name: "Action",
      options: {
        customBodyRender: (val, tableMeta) => {
          return (
            <div style={{ width: "115px" }}>
              <Button
                className="btnAct"
                style={{ marginLeft: 5, backgroundColor: "transparent" }}
                onClick={this.opSidePage(
                  "slide-menu-1",
                  tableMeta.rowIndex,
                  "companyGroup"
                )}
                permission=""
              >
                <i
                  className="fa fa-lw fa-pencil-alt"
                  style={{
                    backgroundColor: "transparent",
                    color: "red",
                    fontSize: 20,
                  }}
                />
              </Button>
              {/* <Button
                                className="btnAct"
                                style={{ marginRight: 15, backgroundColor: 'transparent' }}
                                onClick={() => this.openDeletePopup(tableMeta.rowIndex)}
                                permission={this.state.buttonAccess.btnDelete}
                            >
                                <i className="fa fa-lw fa-trash-alt"
                                    style={{ backgroundColor: 'transparent', color: 'red', fontSize: 20 }} />
                            </Button> */}
              {/* <Button
                                className="btnAct"
                                style={{ marginRight: 15, backgroundColor: 'transparent' }}
                                onClick={this.opSidePage('slide-menu-view', tableMeta.rowIndex)}
                                permission=""
                            >
                                <i className="fa fa-lw fa-ellipsis-v"
                                    style={{ backgroundColor: 'transparent', color: 'red', fontSize: 20 }} />
                            </Button> */}
            </div>
          );
        },
      },
    },
  ];

  opSidePage = (menu, data) => (e) => {
    e.preventDefault();
    let selectedIndex = data;
    this.setState({
      updateVisible: false,
    });

    switch (menu) {
      case "slide-menu-1":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "update",
        });
        break;
      case "slide-menu-view":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "view",
        });
        break;
      default:
        break;
    }
  };
  resetTab = (tabIndex) => {
    this.setState({ tabIndex });
    if (tabIndex === 0) {
      this.getCountPage(this.state.table_page, this.state.table_limit);
    }
  };

  render() {
    if (R.isNil(this.props.auth.user))
      return <Redirect to={{ pathname: "/" }} />;
    let { toCount, table_query } = this.state;
    let tableOptions = {
      ...options,
      serverSide: true,
      count: toCount,
      filter: false,
      search: false,
      viewColumns: false,
      searchText: table_query,
      rowsPerPage: this.state.table_limit,
      page: this.state.table_page,
      onColumnSortChange: (changedColumn, direction) => {
        let order = "desc";
        if (direction === "ascending") {
          order = "asc";
        }

        let columnOrder = "";

        if (changedColumn === "Company") {
          columnOrder = "companyCode";
        }

        if (changedColumn === "Username") {
          columnOrder = "username";
        }

        if (changedColumn === "Email") {
          columnOrder = "email";
        }

        if (changedColumn === "Category") {
          columnOrder = "category";
        }

        if (changedColumn === "Employee Name") {
          columnOrder = "name";
        }

        if (changedColumn === "Status") {
          columnOrder = "status";
        }

        this.columnsUser.map((value, index) => {
          if (changedColumn === value.name && value.name !== "Action") {
            value.options = { sortDirection: order };
          } else {
            value.options = { ...value.options, sortDirection: "none" };
          }
        });

        this.setState(
          {
            dataDto: {
              ...this.state.dataDto,
              sortBy: columnOrder,
              orderBy: order,
            },
          },
          () => {
            this.getCountPage(this.state.table_page, this.state.table_limit);
          }
        );
      },
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.setState({ table_page: tableState.page });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.setState({ table_limit: tableState.rowsPerPage });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "search":
            let searchText = tableState.searchText ? tableState.searchText : "";
            this.setState({ table_query: searchText }, () => {
              this.handleSearch();
            });
            break;
          default:
            break;
        }
      },
    };
    return (
      <div className="main-slider">
        <div className="padding-tbl-monitoring">
          <LoadingBar onRef={(ref) => (this.LoadingBar = ref)} />
          <Tabs
            selectedIndex={this.state.tabIndex}
            onSelect={(tabIndex) => this.resetTab(tabIndex)}
          >
            <TabList>
              <Tab>Master Pricelist</Tab>
            </TabList>
            <TabPanel>
              <div>
                <div
                  style={{
                    display: "flex",
                    marginBottom: "10px",
                    marginTop: "15px",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Button
                      type="button"
                      style={{ width: "130px", height: "40px" }}
                      className="btn btn-plus background-red margin-left-15px"
                      valueCombo={this.state.data.companyIdSelect}
                      onClick={this.openCreateForm.bind(this)}
                    >
                      <span>
                        <i
                          className="fa fa-plus"
                          style={{ marginRight: "10px" }}
                        />
                        Tambah
                      </span>
                    </Button>
                    <Button
                      type="button"
                      style={{ width: "130px", height: "40px" }}
                      className="background-red margin-left-15px"
                      valueCombo={this.state.data.companyIdSelect}
                      // onClick={this.openCreateForm.bind(this)}
                    >
                      <span>
                        <i style={{ marginRight: "10px" }} />
                        Unggah
                      </span>
                    </Button>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: 400,
                    }}
                  >
                    <div>
                      <SimpleInputRowSmall
                        label={"Cari"}
                        name="cari"
                        // readOnly={this.props.type !== "create"}
                        value={this.state.data.cari}
                        onChange={this.onchangeInput}
                      />
                    </div>
                    <div>
                      <Button
                        type="button"
                        style={{ width: 70, height: "40px" }}
                        className="background-red"
                        valueCombo={this.state.data.companyIdSelect}
                        // onClick={this.openCreateForm.bind(this)}
                      >
                        <span>
                          <i />
                          Cari
                        </span>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    key={toCount}
                    title={"Master Price List"}
                    subtitle={"Setting data of Price List"}
                    data={this.state.dataTable}
                    columns={this.columnsUser}
                    options={tableOptions}
                    // buttonCreate={this.state.buttonAccess.btnAdd}
                    // onCreate={this.openCreateForm.bind(this)}
                  />
                </MuiThemeProvider>
                <Button
                  style={{ marginLeft: "1300px", width: "120", marginTop: 10 }}
                  className="btn btn-back"
                  type="button"
                >
                  <span>Print</span>
                </Button>
              </div>
            </TabPanel>
          </Tabs>
        </div>

        <div>
          {this.state.createVisible && (
            <FormPricelist
              type={"create"}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openCreateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.updateVisible && (
            <FormPricelist
              type={this.state.popupType === "update" ? "edit" : "view"}
              data={this.state.rawData[this.state.selectedIndex]}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openUpdateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.savePopUpVisible && (
            <PopUp
              type={"save"}
              class={"app-popup app-popup-show"}
              onClick={this.handlePopUp.bind(this)}
            />
          )}

          {this.state.deletePopUpVisible && (
            <PopUp
              type={"delete"}
              class={"app-popup app-popup-show"}
              onClickDelete={this.handleDelete}
              onClick={this.openDeletePopup}
              isLoading={this.state.loadSave}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    masterdata: state.masterdata,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authLogout: () => dispatch(AuthAction.authLogout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Pricelist);
